import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_AUDIT_PERIOD = "GET_AUDIT_PERIOD";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Audit/GetAuditPeriods/`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AUDIT_PERIOD, service, mock);
